<template>
  <!--
      作者：luoyiming
      时间：2020-06-01
      描述：插件中心-文章-编辑
    -->
  <div class="product-add pb50" v-loading="loading">
    <!--编辑文章-->
     <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
       <div class="common-form">编辑任务</div>
       <el-form-item label="文章标题" prop="title"><el-input v-model="form.title" placeholder="请输入文章标题" class="max-w460"></el-input></el-form-item>
       <el-form-item label="奖金类型">
         <el-radio-group v-model="form.type">
           <el-radio :label="'10'">积分</el-radio>
           <el-radio :label="'20'">余额</el-radio>
         </el-radio-group>
       </el-form-item>
       <el-form-item label="奖金"><el-input type="number" v-model="form.bonus" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
       <el-form-item label="跳转地址" prop="url"><el-input v-model="form.url" placeholder="请输入跳转地址" class="max-w460"></el-input></el-form-item>
       <!--提交-->
       <div class="common-button-wrapper">
         <el-button size="small" type="info" @click="cancelFunc" :loading="loading">取消</el-button>
         <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
       </div>
     </el-form>
  </div>
</template>

<script>
import TaskApi from '@/api/task.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*form表单数据*/
      form: {
        title: '',
        type: '10',
        bonus: 1,
        url: '',
      },

      /*验证规则*/
      rules: {
        title: [{ required: true, message: '请输入任务标题', trigger: 'blur' }],
        url: [{ required: true, message: '请输入跳转地址', trigger: 'blur' }],
      }
    };
  },
  created() {

    this.getDetail();

  },

  methods: {
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.$route.query.task_id;
      TaskApi.getTask({task_id: params},true).then(res => {
          self.form = res.data.model;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*修改任务*/
    onSubmit() {
      let self = this;
      let params = this.form;
      // 取到路由带过来的参数
      TaskApi.saveTask(params, true)
        .then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.$router.push('/plus/task/index');
        })
        .catch(error => {});
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/task/index'
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/codetemplate/task/edit.vue